import { render, staticRenderFns } from "./StickyBox.vue?vue&type=template&id=045b27b2"
import script from "./StickyBox.vue?vue&type=script&lang=js"
export * from "./StickyBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports